import { Box, Skeleton, Stack } from '@mui/material'
import React from 'react'

const CARDS = 8

export default function OptionGridSkeleton() {
  return (
    <Stack spacing={2} sx={{ p: 2 }} data-testid="avatar-option-grid-skeleton">
      <Skeleton variant="text" width={180} height={32} />
      <Box
        sx={{
          display: 'grid',
          gap: 2,
          gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
        }}
      >
        {Array.from({ length: CARDS }, (_, i) => (
          <Skeleton key={i} variant="rounded" height={168} />
        ))}
      </Box>
    </Stack>
  )
}
